import { useGetIglooWorksStatus } from './get-igloo-works-status'

// Note: shared by every surface that needs to know whether a building's Igloo Works
// integration is actually configured — Places → Integrations (the connection status pill, via
// `use-igloo-works-connection.ts`) and the resident profile's Keyless Access tab (both
// designs). The resident tab's own `connected`/`wasConnected` latch is a deliberately separate,
// per-resident concern (see igloo-tab.tsx's in-code note about not stranding a resident whose
// last door was removed) — this building-level check doesn't touch that; it only catches "not
// configured for this building at all" up front.
export const useIsIglooWorksBuildingConnected = (buildingId: number) => {
  const { isLoading, isSuccess } = useGetIglooWorksStatus({ buildingId })

  return {
    isBuildingConnected: isSuccess,
    isLoading,
  }
}
